import { defaultPageSize } from '@synergy/config';
import { request } from '@synergy/api';

import { Account } from '../models/account';
import { BaseState } from './models/base-state';
import { Settings } from '../models/settings';
import { SidebarPanels } from '../../features/activity-sidebar/sidebar-panels';
import { User } from '../models/user';

export class CommonApi {
    constructor(protected baseUrl: string) {}

    private readFromLocalStorage = (): Pick<
        Settings,
        'sidebarCollapsed' | 'pageSize' | 'selectedDetailPanel' | 'activitySidebarCollapsed'
    > => {
        const jsonSettings = localStorage.getItem('synergySettings');
        if (jsonSettings) {
            return JSON.parse(jsonSettings);
        }
        return {
            sidebarCollapsed: false,
            activitySidebarCollapsed: false,
            pageSize: 50,
            selectedDetailPanel: SidebarPanels.Activities,
        };
    };

    public async getBaseState(): Promise<BaseState | null> {
        const response = await request.get(`${this.baseUrl}/`);

        if (!response) {
            return null;
        }

        const localSettings = this.readFromLocalStorage();

        return {
            currentLocale: response.data.locale,
            supportedLocales: response.data.supportedLocales,
            user: User.fromPlainObject(response.data.user),
            poolAccount: Account.fromPlainObject(response.data.poolAccount),
            settings: {
                sidebarCollapsed: localSettings.sidebarCollapsed,
                activitySidebarCollapsed: localSettings.activitySidebarCollapsed,
                selectedDetailPanel: localSettings.selectedDetailPanel,
                pageSize: localSettings.pageSize ?? defaultPageSize,
                currency: response.data.currency,
                apiBaseUrl: response.data.apiBaseUrl,
                mediaBaseUrl: response.data.mediaBaseUrl,
                supportedCurrencies: response.data.supportedCurrencies,
                ftpServer: response.data.ftpServer,
                sftpServer: response.data.sftpServer,
                privateFilesystemPath: `${response.data.apiBaseUrl}${response.data.privateFilesystemPath}`,
                imageCachePaths: {
                    ...response.data.imageCachePaths,
                },
                isImpersonator: response.data.isImpersonator,
                statusScale: response.data.statusScale,
                printCharacterLimit: response.data.printCharacterLimit,
            },
        };
    }
}
